<template>
  <div class="notification-internship-widget">
    <div class="notification-container">
      <div class="header">
        <h1>LIA</h1>
      </div>
      <div class="body">
        <div class="user-widget" v-if="manager_info">
          <img class="user-image" v-if="manager_info.profile_picture"
            :src="$fullUrl('images/profiles/' + manager_info.profile_picture)" />
          <img v-else class="user-image" src="@/assets/icons/logo_avatar.svg" />
          <div class="user-content">
            <h3>
              {{ manager_info.first_name + " " + manager_info.last_name }}
            </h3>
            <p v-if="manager_info.profile">
              {{ manager_info.profile.address }}
            </p>
          </div>
        </div>
        <div class="intership-widget" v-if="internship_data">
          <div class="assingment-body">
            <ul class="assignments-items">
              <li class="assignments-item" v-for="(item, index) in internship_data" :key="index"
                :class="{ active: form_data.internship_id == item.id }">
                <div class="assignments-item-header">
                  <div class="assignments-item-brand">
                    <img src="@/assets/icons/logo_avatar.svg" />
                  </div>
                  <div class="content">
                    <div class="title-row">
                      <label>{{ item.name }}</label>
                      <p class="company" v-if="item.account_id">
                        {{ item.account.name }}
                      </p>
                      <p class="location">{{ item.location }}</p>
                    </div>
                  </div>
                  <div class="time">
                    <span>{{ item.created_at | formatDate }}</span>
                  </div>
                  <button class="toogle-panel-btn" @click="item.expanded = !item.expanded">
                    <img v-if="item.expanded" src="@/assets/admin-icon/allow-blue-up.svg" />
                    <img v-else src="@/assets/admin-icon/allow-blue-down.svg" />
                  </button>
                </div>
                <div class="assignments-item-body" v-if="item.expanded">
                  <div class="assignments-info">
                    <label class="label">Description</label>
                    <p class="assignment-desc">
                      {{ item.description }}
                    </p>
                  </div>
                </div>
                <div class="item-option">
                  <div class="assignment-people">
                    <label>{{ item.students.length }} Candidates </label>
                  </div>
                  <div class="assignment-options">
                    <span v-if="form_data.internship_id == item.id">Selected</span>
                    <button v-else @click="selectInternShip(item)" class="btn-select">
                      Select
                    </button>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="footer">
        <c-button class="btn-save" :loading="accept_loading" @click="confirmNotification()">Accept</c-button>
        <c-button class="btn-cancel" :loading="reject_loading" @click="rejectNotification()">Cancel</c-button>
      </div>
    </div>
  </div>
</template>

<script>
import { eventBus } from "../main";
export default {
  name: "notification-internship",
  components: {},
  computed: {},
  props: {},
  data: () => {
    return {
      form_data: {
        user_id: null,
        internship_id: null,
        not_id: null,
      },
      internship_data: null,
      accept_loading: false,
      reject_loading: false,
      manager_info: null,
    };
  },
  mounted() {
    let vm = this;
    vm.form_data.user_id = vm.$route.params.ref_id;
    vm.form_data.not_id = vm.$route.params.not_id;
    vm.getInternship(vm.$route.params.copy_id);
    vm.getManagerId(vm.$route.params.not_id);
  },
  methods: {
    selectInternShip(item) {
      let vm = this;
      vm.form_data.internship_id = item.id;
    },
    rejectNotification() {
      let vm = this;
      vm.reject_loading = true;
      vm.$store
        .dispatch("STUDENT_REJECT_INTERNSHIP", {
          user_id: vm.$route.params.ref_id,
          not_id: vm.$route.params.not_id,
        })
        .then((value) => {
          vm.reject_loading = false;
          vm.$router.push({ name: "notifications" });
        })
        .catch((reason) => {
          console.log(reason);
          vm.reject_loading = false;
        });
    },
    confirmNotification() {
      let vm = this;
      vm.accept_loading = true;
      vm.$store
        .dispatch("STUDENT_ACCEPT_INTERNSHIP", vm.form_data)
        .then((value) => {
          vm.accept_loading = false;
          vm.$router.push({ name: "notifications" });
        })
        .catch((reason) => {
          console.log(reason);
          vm.accept_loading = false;
        });
    },
    getManagerId(id) {
      let vm = this;
      vm.$store
        .dispatch("GET_STUDENT_INSTRUCTOR_INFO", { not_id: id })
        .then((responce) => {
          vm.manager_info = responce.data;
        })
        .catch((reason) => {
          console.log(reason);
        });
    },
    getInternship(id) {
      let vm = this;
      vm.$store
        .dispatch("STUDENT_GET_INTERNSHIP", { ids: id })
        .then((responce) => {
          vm.internship_data = responce.data.map((item, index) => {
            eventBus.$set(item, "checked", false);
            eventBus.$set(item, "expand_student", false);
            if (index == 0) {
              eventBus.$set(item, "expanded", true);
            } else {
              eventBus.$set(item, "expanded", false);
            }
            return item;
          });
        })
        .catch((reason) => {
          console.log(reason);
        });
    },
  },
  watch: {},
};
</script>

<style lang="scss" scoped>
.notification-internship-widget {
  background: #ededed;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding-top: 55px;
  overflow-y: scroll;
  height: 100vh;

  .notification-container {
    width: 700px;
    background: #fff;
    border-radius: 5px;
    padding: 20px;

    .header {
      padding: 10px;

      h1 {
        margin: 0px;
      }
    }

    .body {
      padding: 10px;

      .user-widget {
        display: flex;
        align-items: center;
        padding-bottom: 10px;
        border-bottom: 1px solid #ddd;
        margin-bottom: 30px;

        .user-image {
          width: 50px;
          height: 50px;
          object-fit: cover;
          margin-right: 15px;
          border-radius: 50%;
        }

        .user-content {
          h3 {
            margin-bottom: 0px;
          }

          p {
            margin-bottom: 0px;
            color: #676767;
            font-size: 12px;
          }
        }
      }

      .intership-widget {
        .assingment-body {
          .loader {
            height: 80px;
            margin-top: 10px;
            background: #fff;
            position: relative;
            padding: 10px 0 0 0;
            -webkit-box-shadow: 0 1px 3px rgba(0, 0, 0, 0.16);
            box-shadow: 0 1px 3px rgba(0, 0, 0, 0.16);
            border-radius: 5px;
            margin-bottom: 20px;

            svg {
              width: 70px !important;
            }
          }

          ul.assignments-items {
            list-style: none;
            padding-left: 0px;
            margin: 0px;
            border-bottom-left-radius: 5px;
            border-bottom-right-radius: 5px;

            @media (min-width: 300px) and (max-width: 630px) {
              padding: 0px 0px;
            }

            .assignments-item {
              background: #ffffff;
              border-radius: 5px;
              margin-bottom: 10px;
              position: relative;
              border: 1px solid rgb(223, 223, 223);
              cursor: pointer;

              @media (min-width: 300px) and (max-width: 630px) {
                padding: 0px 0px;
              }

              &.active {
                background: #1885ad15;
              }

              .inter-check {
                position: absolute;
                top: 4px;
                left: 3px;
              }

              .assignments-item-header {
                display: flex;
                padding: 10px 14px;

                .assignments-item-brand {
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  width: 60px;
                  height: 60px;

                  @media (min-width: 300px) and (max-width: 630px) {
                    width: 60px;
                    height: 60px;
                  }

                  img {
                    width: 50px;
                    height: 50px;
                    border-radius: 50%;
                    object-fit: cover;

                    @media (min-width: 300px) and (max-width: 630px) {
                      width: 50px;
                      height: 50px;
                    }
                  }
                }

                .content {
                  display: flex;
                  width: 100%;
                  padding-right: 5px;
                  padding-left: 10px;
                  justify-content: space-between;
                  align-items: flex-start;
                  padding-top: 6px;

                  .title-row {
                    width: 100%;

                    label {
                      font-size: 18px;

                      font-weight: 800;
                      color: #000;
                      margin-bottom: 3px;
                      overflow: hidden;
                      text-decoration: none;
                      text-overflow: ellipsis;
                      white-space: nowrap;
                      width: 100%;
                      display: block;
                    }

                    p.company {
                      margin: 0px;
                      font-size: 14px;
                      margin-bottom: 3px;
                      overflow: hidden;
                      text-decoration: none;
                      text-overflow: ellipsis;
                      white-space: nowrap;
                      width: 100%;
                      display: block;
                      color: #6c6c6c;
                    }

                    p.location {
                      color: #1ba5a4;
                      margin: 0px;
                      margin-bottom: 3px;
                      font-size: 14px;
                      overflow: hidden;
                      text-decoration: none;
                      text-overflow: ellipsis;
                      white-space: nowrap;
                      width: 100%;
                      display: block;
                    }
                  }
                }

                .toogle-panel-btn {
                  padding: 1px 7px;
                  font-size: 16px;
                  background: transparent;
                  border: none;
                  outline: none;
                  cursor: pointer;
                  color: #ccc;
                  position: absolute;
                  top: 10px;
                  right: 5px;
                  height: 15px;
                }

                .time {
                  padding: 1px 7px;
                  font-size: 12px;
                  background: transparent;
                  border: none;
                  outline: none;
                  cursor: pointer;
                  color: #2693b9;
                  position: absolute;
                  top: 18px;
                  right: 18px;
                  height: 15px;
                  display: flex;
                  align-items: center;

                  img {
                    width: 15px;
                    margin-right: 5px;
                    margin-top: -4px;
                  }
                }
              }

              .assignments-item-body {
                padding-left: 75px;
                padding-right: 20px;
                padding-bottom: 15px;

                .label {
                  margin-bottom: 5px;
                  display: block;
                }

                p.assignment-desc {
                  color: #707070;
                  margin: 0px;
                  margin-bottom: 11px;
                }
              }

              .item-option {
                display: flex;
                justify-content: space-between;
                align-items: flex-start;
                padding: 5px 20px;
                border-top: 1px solid rgb(223, 223, 223);

                .assignment-people {
                  display: flex;
                  flex-direction: column;

                  label {
                    .btn-dropdown {
                      width: 10px;
                      cursor: pointer;
                    }
                  }

                  .people-profiles {
                    display: flex;
                    flex-direction: column;
                    position: relative;
                    left: -4px;
                    margin-top: 5px;

                    .people-item {
                      display: flex;
                      align-items: center;

                      .profile-image {
                        width: 20px;
                        height: 20px;
                        border-radius: 50%;
                        border: 2px solid #fff;
                        object-fit: cover;

                        &.override {
                          margin-left: -6px;
                        }
                      }

                      span {
                        font-size: 11px;
                      }
                    }
                  }
                }

                .assignment-options {
                  .btn-select {
                    background: #0884af;
                    border-radius: 5px;
                    padding: 5px 28px;
                    color: #fff;
                  }
                }
              }
            }
          }

          .empty-widget {
            background: #fff;
            padding: 20px;

            .empty-widget-body {
              height: 150px;
              display: flex;
              align-items: center;
              justify-content: center;
              flex-direction: column;

              p {
                text-align: center;
                width: 270px;
              }

              .add-btn {
                width: 180px;
                height: 45px;
                background: #1890a9 0% 0% no-repeat padding-box;
                border-radius: 4px;
                color: #fff;
                outline: none;
                margin-right: 20px;
                display: center;
                justify-content: center;
              }
            }
          }
        }
      }
    }

    .footer {
      padding: 10px;
      display: flex;
      align-items: center;

      .btn-save {
        width: 100px;
        height: 40px;
        background: #229ea5;
        border-radius: 6px;
        color: #fff;
        margin-right: 20px;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .btn-cancel {
        width: 100px;
        height: 40px;
        background: #fff;
        border-radius: 6px;
        color: #229ea5;
        margin-right: 20px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }
}</style>